<template>
  <div v-if="questions.length > 0" v-on:submit.prevent="storeForm" novalidate>
    <div class="form-row">
      <!-- <div class="col-12 d-flex align-items-center flex-wrap mb-3 flex-column flex-sm-row text-center">
        <h5 class="text-blue-ml">PERGUNTAS ADICIONAIS</h5>
      </div> -->

      <div
        class="form-group"
        :class="{
          'is-invalid': errors[questionIndex],
          'col-12': question.slug == '' || question.slug == null,
          'col-12 col-sm-6 col-md-6 mb-4':
            question.slug != '' && question.slug != null,
        }"
        v-for="(question, questionIndex) in questions"
      >
        <label
          ><span v-if="question.required">*</span> {{ question.title }}</label
        >

        <textarea
          class="form-control"
          rows="5"
          v-if="
            question.htmlType == 'text' &&
            question.slug != 'rg' &&
            question.slug != 'mae' &&
            question.slug != 'pai'
          "
          v-model="question.answer"
        >
        </textarea>

        <!-- <the-mask
          type="tel"
          class="form-control"
          :mask="['##.###.###-X']"
          v-if="question.htmlType == 'text' && question.slug == 'rg'"
          v-model="question.answer" /> -->

        <input
          type="text"
          class="form-control"
          v-if="
            question.htmlType == 'text' &&
            (question.slug == 'rg' ||
              question.slug == 'mae' ||
              question.slug == 'pai')
          "
          v-model="question.answer"
        />

        <selectize
          :settings="selectizeSettings"
          v-if="question.htmlType == 'select'"
          v-model="question.answer"
        >
          <option
            :value="option"
            v-for="(option, index) in question.options.split(';')"
            :key="index"
          >
            {{ option }}
          </option>
        </selectize>

        <div v-if="question.htmlType == 'radio_buttons'">
          <div
            class="custom-control custom-radio custom-control-inline mr-5 mb-2"
            v-for="(option, index) in question.options.split(';')"
            v-if="option != ''"
            :key="index"
          >
            <input
              type="radio"
              class="custom-control-input"
              :name="'radio-' + question.id"
              :id="questionIndex + '-' + index"
              :value="option"
              v-model="question.answer"
            />
            <label
              class="custom-control-label"
              :for="questionIndex + '-' + index"
              >{{ option }}</label
            >
          </div>
        </div>

        <div v-if="question.htmlType == 'check_boxes'">
          <div
            class="custom-control custom-checkbox custom-control-inline mr-5"
            v-for="(option, index) in question.options.split(';')"
            v-if="option != ''"
            :key="index"
          >
            <input
              type="checkbox"
              class="custom-control-input"
              :id="questionIndex + '-' + index"
              :value="option"
              v-model="question.answer"
            />
            <label
              class="custom-control-label"
              :for="questionIndex + '-' + index"
              >{{ option }}</label
            >
          </div>
        </div>

        <div v-if="question.htmlType == 'file_upload'">
          <QuestionAttachment :question="question.id" />
        </div>

        <small>{{ errorsMessages[questionIndex] }}</small>
      </div>
    </div>
  </div>
</template>

<script>
import QuestionAttachment from "@/components/subscription/Questions/QuestionAttachment.vue";
export default {
  name: "FormQuestions",

  data() {
    return {
      questions: [],
      errors: [],
      errorsMessages: [],

      selectizeSettings: {
        create: false,
        createOnBlur: false,
        dropdownParent: "body",
      },
    };
  },

  components: {
    QuestionAttachment,
  },

  computed: {
    defaultQuestions() {
      return this.$store.state.user.profile.additionalQuestions || [];
    },
  },

  async mounted() {
    this.initListeners();

    this.$store
      .dispatch("opportunities/subscriptionQuestions", this.$route.params.id)
      .then((questions) => {
        questions.map((quest) => {
          const question = quest;
          question.answer = question.htmlType == "check_boxes" ? [] : "";

          const isAnswered = this.defaultQuestions.find(
            (dq) => dq.slug == question.slug
          );
          if (isAnswered) {
            question.answer = isAnswered.answer;
          }

          this.questions.push(question);
        });

        setTimeout(() => this.removeAutoFillSelectize(), 500);
      });
  },

  destroyed() {
    this.$EventBus.$off("storeQuestions");
  },

  methods: {
    initListeners() {
      this.$EventBus.$on("storeQuestions", this.storeForm);
    },

    storeForm() {
      this.errors = [];
      this.errorsMessages = [];

      this.questions.map((question, i) => {
        var hasError = false;

        if (question.slug == "mae") {
          hasError =
            (question.answer.length < 2 ||
              question.answer.split(" ").length < 2) &&
            question.required == true;
          this.errors.push(hasError);
          this.errorsMessages.push(
            hasError
              ? "Nome e sobrenome devem conter mais que 2 caracteres."
              : null
          );
        } else if (question.slug == "rg") {
          var numbers = question.answer.match(/\w/g) || [];
          var letters = question.answer.replace(/\d/g, "") || [];
          hasError =
            (question.answer.length < 5 ||
              question.answer.length > 14 ||
              numbers.length < 5 ||
              letters.length > 2 ||
              this.$helpers.allCharactersSame(question.answer)) &&
            question.required == true;
          this.errors.push(hasError);
          this.errorsMessages.push(hasError ? "RG parece inválido" : null);
        } else if (question.htmlType == "file_upload") {
          let el = document.getElementsByClassName("attachment");
          hasError = el.item(0).value == 0 && question.required == true;
          this.errors.push(hasError);
          this.errorsMessages.push(hasError ? "Campo obrigatório" : null);
        } else {
          hasError = question.answer.length == 0 && question.required == true;
          this.errors.push(hasError);
          this.errorsMessages.push(hasError ? "Campo obrigatório" : null);
        }
      });

      if (this.errors.find((elem) => elem == true)) {
        this.$store.commit("OPPORTUNITY_QUESTIONS_FORM", {
          error: true,
        });

        setTimeout(() => {
          Array.from(this.$el.querySelectorAll(".is-invalid")).some((field) => {
            field.querySelector("input, textarea").focus();
            return field;
          });
        }, 100);
      } else {
        this.$store.commit("OPPORTUNITY_QUESTIONS_FORM", {
          data: this.$data,
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.form-row {
  .form-group {
    flex-grow: 1;
    max-width: none;
  }
}

.custom-control .custom-control-label::before,
.custom-control .custom-control-label::after {
  border-color: #ced4da;
}
</style>